<div class="vms-doc-view">
  <div class="p-dialog-header">
    <span class="p-dialog-title">{{title}}</span>
    <div class="p-dialog-header-icons">
      <button type="button" class="p-dialog-header-icon p-dialog-header-maximize p-link"><a
        [download]="fileName" target="_blank" [href]="fileUrl"><i
          class="pi pi-download"></i></a></button>
      <button type="button" class="p-dialog-header-icon p-dialog-header-maximize p-link" (click)="close()"><span
          class="p-dialog-header-close-icon pi pi-times"></span></button>
    </div>
  </div>
  <p-progressSpinner class="doc-loader" *ngIf="loader" [style]="{height:'50vh', display:'flex'}">
  </p-progressSpinner>
  <div class='doc-container' *ngIf="loader">
    <div class='loader'>
      <div class='loader--text'></div>
    </div>
  </div>
  <div *ngIf="isShowViewer">
    <app-doc-viewer [url]="fileUrl" [viewer]="viewer" disableContent="popout"  (loaded)="loaded($event)" [hidden]="loader">
    </app-doc-viewer>
  </div>
  <div style="overflow-x:scroll;">
    <img *ngIf="isShowImg" [src]="fileUrl" (load)="imageLoad($event)" width="100%" height="100%"/>
  </div>
</div>
